import { AppPaths } from '@ftr/routing-paths'
import { SideNavGroup } from './side-nav-item'

export const ADMIN_NAV_GROUP: SideNavGroup = {
  title: 'Admin',
  items: [
    {
      type: 'LINK',
      icon: 'Billing',
      title: 'Plans & Billing',
      path: [`/${AppPaths.NotFound}`],
    },
  ],
}
